{
  "name": "@tramme/editor",
  "version": "0.16.0",
  "license": "Apache-2.0",
  "private": true,
  "type": "module",
  "exports": {
    ".": "./src/main.tsx"
  },
  "dependencies": {
    "@jitsi/rnnoise-wasm": "^0.2.1",
    "@mediapipe/tasks-vision": "^1.1.1",
    "@tramme/api": "*"
  }
}
